// Location: assets/bal-gift-video.js
// What: Starts Gift banner videos only when visible and pauses them offscreen.
// Why: Defers video traffic and retains native controls when autoplay is unavailable.
// RELEVANT FILES: sections/bal-gift-banner.liquid, assets/section-bal-gift-banner.css
if (!customElements.get('bal-gift-video')) {
  customElements.define('bal-gift-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || !('IntersectionObserver' in window) || this.observer) return;
      this.visible = false;
      this.expectedPauses ??= 0;
      this.userPaused ??= false;
      if (!this.initialized) {
        this.video.muted = true;
        this.initialized = true;
        // Keep element-local listeners attached so queued pauses are consumed
        // even while this component is temporarily detached by the editor.
        this.video.addEventListener('pause', () => {
          if (this.expectedPauses > 0) this.expectedPauses--;
          else this.userPaused = true;
        });
        this.video.addEventListener('play', () => { this.userPaused = false; });
      }
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.update = () => {
        if (!this.visible || document.hidden || this.motion.matches) {
          this.pauseVideo();
          return;
        }
        if (this.userPaused || !this.video.paused) return;
        const playback = this.video.play();
        // Native controls remain available when the browser blocks autoplay.
        playback?.catch(() => {});
      };
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.update();
      }, { threshold: 0 });
      this.observer.observe(this.video);
      document.addEventListener('visibilitychange', this.update);
      this.motion.addEventListener('change', this.update);
    }

    pauseVideo() {
      if (!this.video.paused) {
        this.expectedPauses++;
        this.video.pause();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.update);
      this.motion?.removeEventListener('change', this.update);
      if (this.video) this.pauseVideo();
      this.observer = null;
      this.visible = false;
    }
  });
}
